import React from "react";
import ReactTooltip from "react-tooltip";

import TTSDebouncer from "../../foundation/TTSDebouncer";

import "./InputItemList.scss";
import 'react-quill/dist/quill.snow.css';

interface InputItemListProps {
    id?: string,
    value: any,
    className?: string,
    style?: React.CSSProperties,
    disabled?: boolean,
    fullWidth?: boolean,
    "data-tip"?: string | null,
    "data-place"?: string,
    "data-html"?: boolean,
    onChange?: (html: string) => void,
    onFocus?: (range: object) => void,
    onBlur?: (previousRange: object) => void,
    onKeyUp?: (event: React.KeyboardEvent<HTMLInputElement>) => void,
    onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void,
    onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void,
    onDoubleClick?: (event: React.MouseEvent<HTMLSpanElement>) => void
};

interface InputItemListState {
    visible: boolean
}

const tooltipDebouncer = new TTSDebouncer(100);

class InputItemList extends React.Component<InputItemListProps, InputItemListState> {

    state = {
        visible: false
    };

    static getDerivedStateFromProps(props: InputItemListProps, state: InputItemListState): InputItemListState {
        tooltipDebouncer.call(ReactTooltip.rebuild);

        return state;
    }

    render(): React.ReactNode {

        return (
        <span
            className={`itemlist input-items${this.props.fullWidth ? " full" : ""}`}
            onClick={event => this.props.onClick?.(event)}
            onDoubleClick={event => this.props.onDoubleClick?.(event)}>
        </span>
        );

    }

}

export default InputItemList;